<div class="content" [ngClass.gt-sm]="'desktop'" fxLayoutAlign="center center" fxLayout="row">
  <img src="{{licenceService.getKey('logo')}}" alt="loader-logo" />
</div>
